import React from 'react';

// Components
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './GifPickerLoading.scss';

const GifPickerLoading = () => {
  const baseClassName = 'GifPickerLoading';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__column`}>
        <div className={`${baseClassName}__gif-item`}>
          <LoadingShimmer shape="square" width="100%" height="75px" />
        </div>
        <div className={`${baseClassName}__gif-item`}>
          <LoadingShimmer shape="square" width="100%" height="200px" />
        </div>
        <div className={`${baseClassName}__gif-item`}>
          <LoadingShimmer shape="square" width="100%" height="90px" />
        </div>
        <div className={`${baseClassName}__gif-item`}>
          <LoadingShimmer shape="square" width="100%" height="70px" />
        </div>
      </div>
      <div className={`${baseClassName}__column`}>
        <div className={`${baseClassName}__gif-item`}>
          <LoadingShimmer shape="square" width="100%" height="125px" />
        </div>
        <div className={`${baseClassName}__gif-item`}>
          <LoadingShimmer shape="square" width="100%" height="75px" />
        </div>
        <div className={`${baseClassName}__gif-item`}>
          <LoadingShimmer shape="square" width="100%" height="90px" />
        </div>
        <div className={`${baseClassName}__gif-item`}>
          <LoadingShimmer shape="square" width="100%" height="200px" />
        </div>
      </div>
    </div>
  );
};

export default GifPickerLoading;
